import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { ConfigRepository } from '../repositories/ConfigRepository';

export class RatingsReviewsServiceStartedUseCase {
    private configRepository: ConfigRepository;
    private configs: string[];

    //tslint:disable-next-line:no-any
    constructor(configs: any) {
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.configs = configs;
    }

    public execute = async () => {
        await this.configRepository.getConfigs(this.configs);
    };
}
